import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { 
  UserGroupIcon,
  UserIcon
} from '@heroicons/react/24/outline';
import { getImageUrlWithEnv } from '../../utils/imageUrl';
import ImageModal from '../../components/ImageModal';

// API configuration
const getApiUrl = (endpoint) => {
  const baseUrl = 'https://fciveria.ge';
  return `${baseUrl}${endpoint}`;
};

const SocialMedia = () => {
  const [staff, setStaff] = useState([]);
  const [loading, setLoading] = useState(true);
  const [selectedImage, setSelectedImage] = useState(null);

  useEffect(() => {
    loadStaff();
  }, []);

  const loadStaff = async () => {
    try {
      setLoading(true);
      const response = await fetch(getApiUrl('/api/social-staff'));
      if (response.ok) {
        const staffData = await response.json();
        setStaff(staffData);
      }
      setLoading(false);
    } catch (error) {
      console.error('Error loading staff:', error);
      setLoading(false);
    }
  };

  const handleImageClick = (staffMember) => {
    if (staffMember.photoUrl) {
      setSelectedImage({
        imageUrl: getImageUrlWithEnv(staffMember.photoUrl),
        alt: staffMember.name,
        title: staffMember.name,
        subtitle: staffMember.position
      });
    }
  };

  const socialPlatforms = [
    {
      id: 'facebook',
      name: 'Facebook',
      username: '@khashuris.iveria.arena',
      followers: '15.2K',
      posts: 542,
      engagement: '8.5%',
      color: 'bg-blue-600',
      icon: 'f',
      url: 'https://www.facebook.com/khashuris.iveria.arena/',
      description: 'ჩვენი ოფიციალური Facebook გვერდი, სადაც ვაქვეყნებთ ახალი ამბებს, მატჩების შედეგებს და ფოტოებს.'
    },
    {
      id: 'instagram',
      name: 'Instagram',
      username: '@fc_iveria_khashuri_official',
      followers: '8.9K',
      posts: 324,
      engagement: '12.3%',
      color: 'bg-pink-600',
      icon: 'i',
      url: 'https://www.instagram.com/fc_iveria_khashuri_official?igsh=MWlkeWtndG5qYjBnZQ==',
      description: 'Instagram-ზე ვიზიარებთ ყველაზე ლამაზ ფოტოებს და Stories-ს.'
    },
    {
      id: 'youtube',
      name: 'YouTube',
      username: '@IveriaArena',
      followers: '3.2K',
      posts: 89,
      engagement: '15.7%',
      color: 'bg-red-600',
      icon: 'Y',
      url: 'https://www.youtube.com/@IveriaArena',
      description: 'ჩვენი ოფიციალური YouTube არხი ვიდეო კონტენტით, მატჩების ჰაილაითებით და ინტერვიუებით.'
    },
    {
      id: 'tiktok',
      name: 'TikTok',
      username: '@iveriapliusi',
      followers: '2.1K',
      posts: 156,
      engagement: '18.2%',
      color: 'bg-black',
      icon: 'T',
      url: 'https://www.tiktok.com/@iveriapliusi/video/7541348614946245906',
      description: 'TikTok-ზე ვაქვეყნებთ მოკლე და გასართობ ვიდეოებს გუნდის ცხოვრებიდან.'
    }
  ];




  return (
    <div className="min-h-screen bg-gray-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        {/* Header */}
        <div className="text-center mb-12">
          <h1 className="text-4xl font-bold text-gray-900 font-georgian mb-4">
            სოც მედია მენეჯერი
          </h1>
          <p className="text-xl text-gray-600 font-georgian max-w-3xl mx-auto">
            ჩვენი სოციალური მედიის კამპანიები და ციფრული კონტენტი
          </p>
        </div>

        {/* Social Media Stats */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6 mb-12">
          {socialPlatforms.map((platform) => (
            <a
              key={platform.id}
              href={platform.url}
              target="_blank"
              rel="noopener noreferrer"
              className="block bg-white rounded-lg shadow-lg p-6 text-center hover:shadow-xl transition-shadow duration-200 cursor-pointer"
            >
              <div className={`w-16 h-16 ${platform.color} rounded-full flex items-center justify-center text-white font-bold text-2xl mx-auto mb-4`}>
                {platform.icon}
              </div>
              <h3 className="text-lg font-semibold text-gray-900 font-georgian mb-2">{platform.name}</h3>
              <p className="text-sm text-gray-600 font-georgian mb-2">{platform.username}</p>
              <div className="space-y-1 text-sm text-gray-600 font-georgian">
                <p><span className="font-medium">მიმდევრები:</span> {platform.followers}</p>
                <p><span className="font-medium">პოსტები:</span> {platform.posts}</p>
                <p><span className="font-medium">ჩართულობა:</span> {platform.engagement}</p>
              </div>
              <div className="mt-4">
                <span className={`inline-flex items-center ${platform.color} text-white text-xs font-medium px-3 py-1 rounded-full`}>
                  {platform.name}-ზე გადასვლა
                </span>
              </div>
            </a>
          ))}
        </div>

        {/* Platform Tabs */}
       

        {/* Social Media Manager */}
        <div className="bg-white rounded-lg shadow-lg p-8 mb-8">
          <h2 className="text-2xl font-bold text-gray-900 font-georgian mb-6 flex items-center">
            <UserGroupIcon className="h-6 w-6 mr-3" />
            სოც მედია მენეჯერი
          </h2>
          
          {loading ? (
            <div className="text-center py-12">
              <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-blue-600 mx-auto"></div>
              <p className="mt-4 text-gray-600 font-georgian">იტვირთება...</p>
            </div>
          ) : staff.length === 0 ? (
            <div className="text-center py-12">
              <UserGroupIcon className="mx-auto h-12 w-12 text-gray-400" />
              <h3 className="mt-2 text-sm font-medium text-gray-900 font-georgian">პერსონალი არ არის</h3>
              <p className="mt-1 text-sm text-gray-500 font-georgian">სოც მედია პერსონალი ჯერ არ არის დამატებული</p>
            </div>
          ) : (
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-3 gap-6">
              {staff.map((staffMember) => (
                <div key={staffMember.id} className="bg-gray-50 rounded-lg overflow-hidden hover:shadow-lg transition-all duration-300 hover:scale-105">
                  {/* Manager Photo */}
                  <div className="relative h-48 bg-gray-200">
                    {staffMember.photoUrl ? (
                      <img
                        src={getImageUrlWithEnv(staffMember.photoUrl)}
                        alt={staffMember.name}
                        className="w-full h-full object-cover cursor-pointer hover:opacity-90 transition-opacity duration-200"
                        onClick={() => handleImageClick(staffMember)}
                        onError={(e) => {
                          e.target.style.display = 'none';
                          e.target.nextSibling.style.display = 'flex';
                        }}
                      />
                    ) : null}
                    <div 
                      className={`w-full h-full ${staffMember.photoUrl ? 'hidden' : 'flex'} items-center justify-center bg-gradient-to-br from-blue-500 to-blue-700`}
                    >
                      <UserIcon className="h-16 w-16 text-white" />
                    </div>
                  </div>
                  
                  {/* Manager Info */}
                  <div className="p-4">
                    <h3 className="font-bold text-gray-900 font-georgian text-lg mb-1">{staffMember.name}</h3>
                    <p className="text-sm text-blue-600 font-georgian mb-2">{staffMember.position}</p>
                    
                    <div className="space-y-1 text-sm text-gray-600 font-georgian">
                      {staffMember.age && <p>ასაკი: {staffMember.age} წელი</p>}
                      {staffMember.experienceYears && <p>გამოცდილება: {staffMember.experienceYears} წელი</p>}
                      {staffMember.phone && (
                        <a 
                          href={`tel:${staffMember.phone}`}
                          className="block text-blue-600 hover:text-blue-800 transition-colors"
                        >
                          {staffMember.phone}
                        </a>
                      )}
                      {staffMember.email && (
                        <a 
                          href={`mailto:${staffMember.email}`}
                          className="block text-green-600 hover:text-green-800 transition-colors"
                        >
                          {staffMember.email}
                        </a>
                      )}
                    </div>
                    
                    {staffMember.description && (
                      <p className="mt-3 text-xs text-gray-500 font-georgian line-clamp-3">
                        {staffMember.description}
                      </p>
                    )}
                  </div>
                </div>
              ))}
            </div>
          )}
        </div>


        {/* Navigation */}

        {/* Image Modal */}
        <ImageModal
          isOpen={selectedImage !== null}
          onClose={() => setSelectedImage(null)}
          imageUrl={selectedImage?.imageUrl}
          alt={selectedImage?.alt}
          title={selectedImage?.title}
          subtitle={selectedImage?.subtitle}
        />
      </div>
    </div>
  );
};

export default SocialMedia;
